import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as AuthActions from '../actions/Auth';
import * as HeaderActions from '../actions/Header';
import Menu from '../components/Menu';

const mapStateToProps = (state: any) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    headerActions: bindActionCreators(HeaderActions, dispatch),
    authActions: bindActionCreators(AuthActions, dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Menu as any);



// WEBPACK FOOTER //
// ./src/containers/Menu.tsx